// extracted by mini-css-extract-plugin
export default {"description":"AbilityWelcome-module__description__aj9TF","paragraph":"AbilityWelcome-module__paragraph__n5ksA"};